import { AnyAction } from "redux";

import { myFleetActions } from "../reducer/reducer";
import { MyFleetFilter } from "features/myFleet/types";

export const setFilter = (filter: MyFleetFilter): AnyAction =>
  myFleetActions.setFilter(filter);
